import {  cutOptions, suportOptions, useOptions, NEON_FONTS} from '../constants/options';

export const getBase64FromImageUrl = async (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a base64
      };
      img.onerror = (err) => reject(err);
    });
  };


export const getBase64FromSVG = async (url) => {
    const response = await fetch(url);
    const text = await response.text();
    const base64SVG = btoa(unescape(encodeURIComponent(text)));
    return `data:image/svg+xml;base64,${base64SVG}`;
  };

  function escapeHTML(str = '') {
    return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  export function generateSVGfromTexts(stageWidth, stageHeight, texts) {
    const allFontsImport = NEON_FONTS
      .map(font => {
        const sanitizedUrl = font.url.replace(/&/g, '&amp;');
        return `@import url('${sanitizedUrl}');`;
      })
      .join('\n');
  
    const svgHeader = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="${stageWidth}"
    height="${stageHeight}"
    style="background:transparent;"
  >
    <defs>
      <style type="text/css">
        ${allFontsImport}
        text {
          dominant-baseline: text-before-edge;
        }
      </style>
    </defs>
  `;
  
    let svgBody = '';
  
    texts.forEach((textObj) => {
      // Evita negativos y agrega un margen de 20 px
      const safeX = Math.max(0, textObj.x) + 20;
      const safeY = Math.max(0, textObj.y);
    
      const lines = textObj.text.split('\n');
      svgBody += `
        <text
          x="${safeX}"
          y="${safeY}"
          font-family="${textObj.fontFamily}"
          font-size="${textObj.fontSize}"
          fill="${textObj.color}"
          text-anchor="start"
        >
          ${
            lines.map((line, i) => {
              const dy = i === 0 ? 0 : textObj.fontSize;
              // tspan con la misma x, y un 'dy' para saltar renglón
              return `
                <tspan x="${safeX}" dy="${dy}">
                  ${escapeHTML(line)}
                </tspan>
              `;
            }).join('')
          }
        </text>
      `;
    });
  
    const svgFooter = `</svg>`;
  
    return svgHeader + svgBody + svgFooter;
  }
  


  const getOptionLabel = (options, value) => {
    const option = options.find(opt => opt.value === value);
    return option ? option.label : value;
  };
  
  const getFileNameFromBase64 = (base64String) => {
    const match = base64String.match(/data:image\/(\w+);base64,/);
    if (match) {
      return `uploaded_image.${match[1]}`;
    }
    return 'uploaded_image';
  };
  

export const formatCanvasData = (canvasData) => {

  const {
    contentType,
    texts = [],
    uploadedImages = [],
    description,
    size,
    cut,
    support,
    use,
    canvasImage, 
    backgroundImage, 
    totalPrice, 
    priceSummary,
  } = canvasData;

  return {
    text: `
      📌 Datos del Canvas:
      🖌️ Tipo de Contenido: ${contentType || "No especificado"}
      📐 Tamaño: ${size?.width || 0} x ${size?.height || 0}
      ✂️ Recorte: ${getOptionLabel(cutOptions, cut) || "No definido"}
      🏗️ Soporte: ${getOptionLabel(suportOptions, support) || "No definido"}
      🎯 Uso: ${getOptionLabel(useOptions, use) || "No definido"}
      ${contentType === 'text' ? `
      🔤 Textos:
      ${texts.map((text, index) => `
        ${index + 1}. "${text.text}" (Fuente: ${text.fontFamily}, Color: ${text.color}, Tamaño: ${text.fontSize})
        Posición: (${text.x}, ${text.y})
      `).join("\n")}` : ''}
      ${contentType === 'image' ? `
      🖼️ Imágenes Subidas:
      ${uploadedImages.length > 0 ? uploadedImages.map((img, index) => `🔹 Imagen ${index + 1}: ${getFileNameFromBase64(img)}`).join("\n") : "No hay imágenes subidas"}
      📜 Descripción: ${description || "No hay descripción"}` : ''}
      💰 Precio Aproximado: ${totalPrice} €
      ${priceSummary}
    `,
    image: canvasImage,
    backgroundImage, 
    uploadedImage: contentType === 'image' && uploadedImages.length > 0 ? uploadedImages[0] : null,
  };
};